// extracted by mini-css-extract-plugin
export default {"imageBox":"index_imageBox__pTnCa","rect":"index_rect__Qz33G","round":"index_round__KDbtf","uploadButton":"index_uploadButton__8qQ4v"};